export type AuthId = string | null
export type WireAuthId = string | number | null

const DECIMAL_ID = /^[1-9]\d*$/

/** Normalize legacy numeric auth IDs exactly once, at the JSON boundary. */
export function normalizeAuthId(value: WireAuthId, field: string): AuthId {
  if (value === null) return null
  if (typeof value === 'number') {
    if (!Number.isSafeInteger(value) || value <= 0) {
      throw new TypeError(`${field} must be a safe positive integer or decimal string`)
    }
    return String(value)
  }
  if (!DECIMAL_ID.test(value)) {
    throw new TypeError(`${field} must be a positive decimal string`)
  }
  return value
}

/** Stored sessions must already be normalized; numbers are never accepted here. */
export function isAuthId(value: unknown): value is AuthId {
  return value === null || (typeof value === 'string' && DECIMAL_ID.test(value))
}
